var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({staticClass:"avatar",class:{ 'disabled': _vm.disabled },style:({ backgroundColor: _vm.color }),on:{"click":_vm.onClick}},'div',attrs,false),on),[_vm._v("\n        "+_vm._s(_vm.initials)+"\n      ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.name))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }